// Styles
import styles from './FormTabAnchors.module.css';

// Utils
import cn from '../../../utils/cn';

/**
 * Container component for fieldset navigation anchors
 * @param {object} props - Component props
 * @param {FormFieldset[]} props.fieldsets - Array of fieldsets to create anchors for
 * @param {(fieldset: FormFieldset) => JSX.Element} props.children - Render prop function
 * @param {string} [props.className] - Additional CSS classes
 * @returns {JSX.Element} FormTabAnchors component
 */
function FormTabAnchors({ fieldsets, children, className = '' }) {
  if (!fieldsets || fieldsets.length === 0) return null;

  return (
    <nav className={cn([styles['form-tab-anchors'], className])} role="navigation" aria-label="Fieldset navigation">
      <ul className={styles['anchors-list']}>
        {fieldsets.map((fieldset) => (
          <li key={fieldset.id} className={styles['anchor-item']}>
            {children(fieldset)}
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default FormTabAnchors;
